import signals from 'signals'
import * as PIXI from "pixi.js";
import LocalizedPIXIText from "./LocalizedPIXIText";
import LocalizedHTMLText from "./LocalizedHTMLText";

export default class TextFactory {

  static DEFAULT_LOCALE = 'en'

  constructor (styles, strings, initLocale, isHTMLText = true) {
    this.styles = styles.styles
    this.strings = strings
    let a = this.styles[0]
    this.isHTMLText = isHTMLText
    this.localeTextArray = []
    this.currLocale = initLocale
    this.actionSignal = new signals.Signal()
  }

  getStyle(identifier) {
    return new PIXI.TextStyle(this.styles[identifier])
  }

  getTextWithStyle = (identifier) => {
    if(!this.strings[identifier]) {
      console.log('TextFactory ERROR identifier', identifier)
    }
    let locale = this.checkStringLocale(identifier, this.currLocale)
    let sn = this.strings[identifier][locale]['styleName']

    let s = new PIXI.TextStyle(this.styles[sn])
    let text = this.getLocalizedText(identifier)
    let pt = this.isHTMLText ? new LocalizedHTMLText(text, s, identifier) : new LocalizedPIXIText(text, s, identifier)

    this.localeTextArray.push(pt)
    return pt
  }

  getContainerTextWithStyle = (identifier) => {
    // for iPhone issue(when used strokeThickness and dropShadow)
    let locale = this.checkStringLocale(identifier, this.currLocale)
    let sn = this.strings[identifier][locale]['styleName']
    let s = new PIXI.TextStyle(this.styles[sn])
    s.dropShadow = false;
    let text = this.getLocalizedText(identifier)
    let pt = new LocalizedPIXIText(text, s, identifier)
    this.localeTextArray.push(pt)

    s = new PIXI.TextStyle(this.styles[sn+'Under'])
    let pt2 = new LocalizedPIXIText(text, s, identifier)
    this.localeTextArray.push(pt2)

    let container = new PIXI.Container()
    pt.anchor.set(0.5)
    pt2.anchor.set(0.5)
    container.addChild(pt2);
    container.addChild(pt);

    return container
  }

  getStringByIdentifier (identifier, value = null) {
    let text = ''
    if (this.strings[identifier]) {
      let locale = this.checkStringLocale(identifier, this.currLocale)
      text = this.strings[identifier][locale].text
    }
    if(value) {
      let str = /<value>/gi
      let newStr = text.replace(str, value)
      return newStr
    }
    return text
  }

  getLocalizedText(identifier) {
     const locale = this.checkStringLocale(identifier, this.currLocale)
     return this.strings[identifier][locale].text
  }

  isExisted(identifier) {
    return this.strings[identifier]
  }

  changeLocaleAndRefresh (locale) {
    this.currLocale = locale
    for (let i = 0; i < this.localeTextArray.length; i++) {
      const identifier = this.localeTextArray[i].identifier
      this.localeTextArray[i].text = this.getStringByIdentifier(identifier)
      const locale = this.checkStringLocale(identifier, this.currLocale)
      let sn = this.strings[identifier][locale]['styleName']
      let s = new PIXI.TextStyle(this.styles[sn])
      this.localeTextArray[i].style = s
    }
    this.actionSignal.dispatch({ action: 'changeLocale', data: this.currLocale })
  }

  onResize(data) {
    if(!this.elements) {return}
    clearTimeout(this.t)
    this.t = setTimeout(() => {
     for (let i = 0; i < this.elements.length; i++) {
       let r = this.localeTextArray[i].resolution ? this.localeTextArray[i].resolution : 3
        this.localeTextArray[i].resolution = data.scale * this.localeTextArray[i].resolution
      }
    }, 200)
  }

  set isHTMLText (value) {
    this._isHTMLText = value
    if(false) {
      this._isHTMLText = false
    }
  }

  get isHTMLText() {
    return this._isHTMLText
  }

  checkStringLocale(identifier, currentLocale){
    if(!this.strings[identifier][currentLocale]) {
      console.log('Wrong localization ', currentLocale, ' for ', identifier)
      return TextFactory.DEFAULT_LOCALE
    }
    return currentLocale
  }
}
